module.exports = __webpack_public_path__ + "static/img/achievments_bg.743e441.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achievments_bg.jpg
// module id = FQXs
// module chunks = 0